import { Outlet, createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { getGetBuslineQueryOptions } from '@area-restrita/api-client/endpoints/buslines/buslines.gen';

import PageContainer from '@/components/layout/PageContainer';
import SidebarNav from '@/components/layout/SidebarNav';

const buslineParamsSchema = z.object({
  buslineId: z.coerce.number(),
});

export const Route = createFileRoute(
  '/_authenticated/_system/_tenant/buslines/$buslineId',
)({
  parseParams: buslineParamsSchema.parse,
  loader: async ({ params: { buslineId }, context: { queryClient } }) => {
    const busline = await queryClient.ensureQueryData(
      getGetBuslineQueryOptions(buslineId),
    );

    return busline;
  },
  component: function BuslinePageRoute() {
    const busline = Route.useLoaderData();

    return (
      <PageContainer
        title={`Rota: ${busline.code} - ${busline.name}`}
        subtitle="Detalhes da linha de ônibus"
        withSeparator
      >
        <div className="flex flex-col space-y-8 lg:flex-row lg:space-x-12 lg:space-y-0">
          <aside className="-mx-4 lg:w-1/5">
            <SidebarNav
              items={[
                {
                  label: 'Geral',
                  to: '/buslines/$buslineId',
                },
                {
                  label: 'Execuções',
                  to: '/buslines/$buslineId/acting',
                },
              ]}
            />
          </aside>
          <div className="flex-1">
            <Outlet />
          </div>
        </div>
      </PageContainer>
    );
  },
});
